// extracted by mini-css-extract-plugin
export default {"header":"home_header__TC78t","delete":"home_delete__3aDPh","products":"home_products__MOuNc"};